import { render, staticRenderFns } from "./customer_services.vue?vue&type=template&id=2cf0e2ed&scoped=true&"
import script from "./customer_services.vue?vue&type=script&lang=js&"
export * from "./customer_services.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cf0e2ed",
  null
  
)

export default component.exports